// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| EzClocker Border UX CSS Classes
| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
:root {
  --ezBorderColorBlack: var(--ezClockerBlack);
  --ezBorderColorGray: var(--ezClockerGray);
  --ezBorderColorStone: var(--ezClockerStone);
  --ezBorderColorSilver: var(--ezClockerSilver);
  --ezBorderColorOffWhite: var(--ezClockerOffWhite);
  --ezBorderColorNavy: var(--ezClockerNavy);
  --ezBorderStyle: solid;
  --ezBorderWidth: 1px;
  --ezBorderRadius: 3px;
  --ezBorderMedium: 3px;
  --ezBorderMediumRadius: 3px;
  --ezBorderThick: 4px;
  --ezBorderThickRadius: 3px;
}

.ezBorders-radius {
  border-radius: var(--ezBorderRadius);
}

.ezBorders-top-radius {
  border-top-left-radius: var(--ezBorderRadius);
  border-top-right-radius: var(--ezBorderRadius);
}

.ezBorders-bottom-radius {
  border-bottom-left-radius: var(--ezBorderRadius);
  border-bottom-right-radius: var(--ezBorderRadius);
}

/* 1px borders */
.ezBorder {
  border-color: var(--ezBorderColorGray);
  border-style: var(--ezBorderStyle);
  border-width: var(--ezBorderWidth);
}

.ez-border-rounded {
  border-color: var(--ezBorderColorGray);
  border-style: var(--ezBorderStyle);
  border-width: var(--ezBorderWidth);
  border-radius: var(--ezBorderRadius);
}

.ez-border-navy {
  border-color: var(--ezBorderColorNavy);
  border-style: var(--ezBorderStyle);
  border-width: var(--ezBorderWidth);
}

.ez-border-medium-navy {
  border-color: var(--ezBorderColorNavy);
  border-style: var(--ezBorderStyle);
  border-width: var(--ezBorderMedium);
}

.ez-border-medium-rounded-navy {
  border-color: var(--ezBorderColorNavy);
  border-style: var(--ezBorderStyle);
  border-width: var(--ezBorderMedium);
  border-radius: var(--ezBorderRadius);
}

.ez-border-medium-rounded-right-navy {
  border-color: var(--ezBorderColorNavy);
  border-style: var(--ezBorderStyle);
  border-width: var(--ezBorderMedium);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: var(--ezBorderRadius);
  border-bottom-right-radius: var(--ezBorderRadius);
}

.ez-border-thick-navy {
  border-color: var(--ezBorderColorNavy);
  border-style: var(--ezBorderStyle);
  border-width: var(--ezBorderThick);
  border-radius: var(----ezBorderRadius);
}

.ezBorders_Stone {
  border-color: var(--ezBorderColorStone);
  border-style: var(--ezBorderStyle);
  border-width: var(--ezBorderWidth);
}

.ezBorders_Silver {
  border-color: var(--ezBorderColorStone);
  border-style: var(--ezBorderStyle);
  border-width: var(--ezBorderWidth);
}

.ezBorders_OffWhite {
  border-color: var(--ezBorderColorStone);
  border-style: var(--ezBorderStyle);
  border-width: var(--ezBorderWidth);
}

.ezBorderLeft {
  /* border-color: var(--ezClockerGray); */
  border-color: #6d6e70;
  /* border-left-style: var(--ezBorderStyle); */
  border-left-style: solid;
  /* border-left-width: var(--ezBorderWidth) */
  border-left-width: 1px;
}

.ezBorderLeftBottom {
  /* border-color: var(--ezClockerGray); */
  border-color: #6d6e70;
  /* border-left-style: var(--ezBorderStyle); */
  border-left-style: solid;
  /* border-left-width: var(--ezBorderWidth) */
  border-left-width: 1px;
  /* border-bottom-style: var(--ezBorderStyle); */
  border-bottom-style: solid;
  /* border-bottom-width: var(--ezBorderWidth) */
  border-bottom-width: 1px;
}

.ezBorderRight {
  /* border-color: var(--ezClockerGray); */
  border-color: #6d6e70;
  border-right-style: solid;
  border-right-width: 1px;
}

.ezBorderBottom {
  /* border-color: var(--ezClockerGray); */
  border-color: #6d6e70;
  border-right-style: solid;
  border-right-width: 1px;
  border-bottom-style: solid;
  border-bottom-width: 1px;
}

.ezBorderLeftRightBottom {
  /* border-color: var(--ezClockerGray); */
  border-color: #6d6e70;
  border-left-style: solid;
  border-left-width: 1px;
  border-right-style: solid;
  border-right-width: 1px;
  border-bottom-style: solid;
  border-bottom-width: 1px;
}

.ezSolidBorder1 {
  /* border-color: var(--ezClockerGray); */
  border-color: #6d6e70;
  border-style: solid;
  border-width: 1px;
}

.ezSolidBorderTop1 {
  /* border-color: var(--ezClockerGray); */
  border-color: #6d6e70;
  border-top-style: solid;
  border-top-width: 1px;
}

.ezSolidBorderBottom1 {
  /* border-color: var(--ezClockerGray); */
  border-color: #6d6e70;
  border-bottom-style: solid;
  border-bottom-width: 1px;
}

.ezSolidBorderTopBottom1 {
  /* border-color: var(--ezClockerGray); */
  border-color: #6d6e70;
  border-top-style: solid;
  border-top-width: 1px;
  border-bottom-style: solid;
  border-bottom-width: 1px;
}

.ezSolidBorderLeft1 {
  /* border-color: var(--ezClockerGray); */
  border-color: #6d6e70;
  border-left-style: solid;
  border-left-width: 1px;
}

.ezSolidBorderRight1 {
  /* border-color: var(--ezClockerGray); */
  border-color: #6d6e70;
  border-right-style: solid;
  border-right-width: 1px;
}

.ezSolidBorderLeftRigt1 {
  /* border-color: var(--ezClockerGray); */
  border-color: #6d6e70;
  border-left-style: solid;
  border-left-width: 1px;
  border-right-style: solid;
  border-right-width: 1px;
}

/* 2px borders */
.ezSolidBorder2 {
  /* border-color: var(--ezClockerGray); */
  border-color: #6d6e70;
  border-style: solid;
  border-width: 2px;
}

.ezSolidBorderTop2 {
  /* border-color: var(--ezClockerGray); */
  border-color: #6d6e70;
  border-top-style: solid;
  border-top-width: 2px;
}

.ezSolidBorderBottom2 {
  /* border-color: var(--ezClockerGray); */
  border-color: #6d6e70;
  border-bottom-style: solid;
  border-bottom-width: 2px;
}

.ezSolidBorderTopBottom2 {
  /* border-color: var(--ezClockerGray); */
  border-color: #6d6e70;
  border-top-style: solid;
  border-top-width: 2px;
  border-bottom-style: solid;
  border-bottom-width: 2px;
}

.ezSolidBorderLeft2 {
  /* border-color: var(--ezClockerGray); */
  border-color: #6d6e70;
  border-left-style: solid;
  border-left-width: 2px;
}

.ezSolidBorderRight2 {
  /* border-color: var(--ezClockerGray); */
  border-color: #6d6e70;
  border-right-style: solid;
  border-right-width: 2px;
}

.ezSolidBorderLeftRigt2 {
  /* border-color: var(--ezClockerGray); */
  border-color: #6d6e70;
  border-left-style: solid;
  border-left-width: 2px;
  border-right-style: solid;
  border-right-width: 2px;
}

/* 4px borders */
.ezSolidBorder4 {
  /* border-color: var(--ezClockerGray); */
  border-color: #6d6e70;
  border-style: solid;
  border-width: 4px;
}

.ezSolidBorderTop4 {
  /* border-color: var(--ezClockerGray); */
  border-color: #6d6e70;
  border-top-style: solid;
  border-top-width: 4px;
}

.ezSolidBorderBottom4 {
  /* border-color: var(--ezClockerGray); */
  border-color: #6d6e70;
  border-bottom-style: solid;
  border-bottom-width: 4px;
}

.ezSolidBorderTopBottom4 {
  /* border-color: var(--ezClockerGray); */
  border-color: #6d6e70;
  border-top-style: solid;
  border-top-width: 4px;
  border-bottom-style: solid;
  border-bottom-width: 4px;
}

.ezSolidBorderLeft4 {
  /* border-color: var(--ezClockerGray); */
  border-color: #6d6e70;
  border-left-style: solid;
  border-left-width: 4px;
}

.ezSolidBorderRight4 {
  /* border-color: var(--ezClockerGray); */
  border-color: #6d6e70;
  border-right-style: solid;
  border-right-width: 4px;
}

.ezSolidBorderLeftRigt4 {
  /* border-color: var(--ezClockerGray); */
  border-color: #6d6e70;
  border-left-style: solid;
  border-left-width: 4px;
  border-right-style: solid;
  border-right-width: 4px;
}

.ezRadius2 {
  border-radius: 2px;
}

.ezRadiusTopLeft2 {
  border-top-left-radius: 2px;
}

.ezRadisuTopRight2 {
  border-top-right-radius: 2px;
}

.ezRadiusTop2 {
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
}

.ezRadiusBottomLeft2 {
  border-bottom-left-radius: 2px;
}

.ezRadisuBottomRight2 {
  border-bottom-right-radius: 2px;
}

.ezRadisuBottom2 {
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
}

.ezRadiusLeft2 {
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}

.ezRadiusRight2 {
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}

.ezRadius4 {
  border-radius: 4px;
}

.ezRadiusTopLeft4 {
  border-top-left-radius: 4px;
}

.ezRadiusTopRight4 {
  border-top-right-radius: 4px;
}

.ezRadiusTop4 {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.ezRadiusBottomLeft4 {
  border-bottom-left-radius: 4px;
}

.ezRadisuBottomRight4 {
  border-bottom-right-radius: 4px;
}

.ezRadisuBottom4 {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.ezRadiusLeft4 {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.ezRadiusRight4 {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./public/styles/common/ez-borders.css"],"names":[],"mappings":"AAAA;;;iEAAA;AAKA;EACI,2CAAA;EACA,yCAAA;EACA,2CAAA;EACA,6CAAA;EACA,iDAAA;EACA,yCAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,2BAAA;EACA,oBAAA;EACA,0BAAA;AAAJ;;AAGA;EACI,oCAAA;AAAJ;;AAGA;EACI,6CAAA;EACA,8CAAA;AAAJ;;AAGA;EACI,gDAAA;EACA,iDAAA;AAAJ;;AAIA,gBAAA;AACA;EACI,sCAAA;EACA,kCAAA;EACA,kCAAA;AADJ;;AAIA;EACI,sCAAA;EACA,kCAAA;EACA,kCAAA;EACA,oCAAA;AADJ;;AAIA;EACI,sCAAA;EACA,kCAAA;EACA,kCAAA;AADJ;;AAIA;EACI,sCAAA;EACA,kCAAA;EACA,mCAAA;AADJ;;AAIA;EACI,sCAAA;EACA,kCAAA;EACA,mCAAA;EACA,oCAAA;AADJ;;AAIA;EACI,sCAAA;EACA,kCAAA;EACA,mCAAA;EACA,yBAAA;EACA,4BAAA;EACA,8CAAA;EACA,iDAAA;AADJ;;AAIA;EACI,sCAAA;EACA,kCAAA;EACA,kCAAA;EACA,sCAAA;AADJ;;AAIA;EACI,uCAAA;EACA,kCAAA;EACA,kCAAA;AADJ;;AAIA;EACI,uCAAA;EACA,kCAAA;EACA,kCAAA;AADJ;;AAIA;EACI,uCAAA;EACA,kCAAA;EACA,kCAAA;AADJ;;AAIA;EACI,wCAAA;EACA,qBAAA;EAEA,6CAAA;EACA,wBAAA;EAEA,4CAAA;EACA,sBAAA;AAHJ;;AAMA;EACI,wCAAA;EACA,qBAAA;EAEA,6CAAA;EACA,wBAAA;EAEA,4CAAA;EACA,sBAAA;EAEA,+CAAA;EACA,0BAAA;EAEA,8CAAA;EACA,wBAAA;AAPJ;;AAUA;EACI,wCAAA;EACA,qBAAA;EACA,yBAAA;EACA,uBAAA;AAPJ;;AAUA;EACI,wCAAA;EACA,qBAAA;EACA,yBAAA;EACA,uBAAA;EACA,0BAAA;EACA,wBAAA;AAPJ;;AAUA;EACI,wCAAA;EACA,qBAAA;EACA,wBAAA;EACA,sBAAA;EACA,yBAAA;EACA,uBAAA;EACA,0BAAA;EACA,wBAAA;AAPJ;;AAUA;EACI,wCAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;AAPJ;;AAUA;EACI,wCAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;AAPJ;;AAUA;EACI,wCAAA;EACA,qBAAA;EACA,0BAAA;EACA,wBAAA;AAPJ;;AAUA;EACI,wCAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,0BAAA;EACA,wBAAA;AAPJ;;AAUA;EACI,wCAAA;EACA,qBAAA;EACA,wBAAA;EACA,sBAAA;AAPJ;;AAUA;EACI,wCAAA;EACA,qBAAA;EACA,yBAAA;EACA,uBAAA;AAPJ;;AAUA;EACI,wCAAA;EACA,qBAAA;EACA,wBAAA;EACA,sBAAA;EACA,yBAAA;EACA,uBAAA;AAPJ;;AAUA,gBAAA;AACA;EACI,wCAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;AAPJ;;AAUA;EACI,wCAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;AAPJ;;AAUA;EACI,wCAAA;EACA,qBAAA;EACA,0BAAA;EACA,wBAAA;AAPJ;;AAUA;EACI,wCAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,0BAAA;EACA,wBAAA;AAPJ;;AAUA;EACI,wCAAA;EACA,qBAAA;EACA,wBAAA;EACA,sBAAA;AAPJ;;AAUA;EACI,wCAAA;EACA,qBAAA;EACA,yBAAA;EACA,uBAAA;AAPJ;;AAUA;EACI,wCAAA;EACA,qBAAA;EACA,wBAAA;EACA,sBAAA;EACA,yBAAA;EACA,uBAAA;AAPJ;;AAUA,gBAAA;AACA;EACI,wCAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;AAPJ;;AAUA;EACI,wCAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;AAPJ;;AAUA;EACI,wCAAA;EACA,qBAAA;EACA,0BAAA;EACA,wBAAA;AAPJ;;AAUA;EACI,wCAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,0BAAA;EACA,wBAAA;AAPJ;;AAUA;EACI,wCAAA;EACA,qBAAA;EACA,wBAAA;EACA,sBAAA;AAPJ;;AAUA;EACI,wCAAA;EACA,qBAAA;EACA,yBAAA;EACA,uBAAA;AAPJ;;AAUA;EACI,wCAAA;EACA,qBAAA;EACA,wBAAA;EACA,sBAAA;EACA,yBAAA;EACA,uBAAA;AAPJ;;AAUA;EACI,kBAAA;AAPJ;;AAUA;EACI,2BAAA;AAPJ;;AAUA;EACI,4BAAA;AAPJ;;AAUA;EACI,2BAAA;EACA,4BAAA;AAPJ;;AAUA;EACI,8BAAA;AAPJ;;AAUA;EACI,+BAAA;AAPJ;;AAUA;EACI,8BAAA;EACA,+BAAA;AAPJ;;AAUA;EACI,2BAAA;EACA,8BAAA;AAPJ;;AAUA;EACI,4BAAA;EACA,+BAAA;AAPJ;;AAUA;EACI,kBAAA;AAPJ;;AAUA;EACI,2BAAA;AAPJ;;AAUA;EACI,4BAAA;AAPJ;;AAUA;EACI,2BAAA;EACA,4BAAA;AAPJ;;AAUA;EACI,8BAAA;AAPJ;;AAUA;EACI,+BAAA;AAPJ;;AAUA;EACI,8BAAA;EACA,+BAAA;AAPJ;;AAUA;EACI,2BAAA;EACA,8BAAA;AAPJ;;AAUA;EACI,4BAAA;EACA,+BAAA;AAPJ","sourcesContent":["/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| EzClocker Border UX CSS Classes\r\n| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\n\r\n:root {\r\n    --ezBorderColorBlack: var(--ezClockerBlack);\r\n    --ezBorderColorGray: var(--ezClockerGray);\r\n    --ezBorderColorStone: var(--ezClockerStone);\r\n    --ezBorderColorSilver: var(--ezClockerSilver);\r\n    --ezBorderColorOffWhite: var(--ezClockerOffWhite);\r\n    --ezBorderColorNavy: var(--ezClockerNavy);\r\n    --ezBorderStyle: solid;\r\n    --ezBorderWidth: 1px;\r\n    --ezBorderRadius: 3px;\r\n    --ezBorderMedium: 3px;\r\n    --ezBorderMediumRadius: 3px;\r\n    --ezBorderThick: 4px;\r\n    --ezBorderThickRadius: 3px;\r\n}\r\n\r\n.ezBorders-radius {\r\n    border-radius: var(--ezBorderRadius);\r\n}\r\n\r\n.ezBorders-top-radius {\r\n    border-top-left-radius: var(--ezBorderRadius);\r\n    border-top-right-radius: var(--ezBorderRadius);\r\n}\r\n\r\n.ezBorders-bottom-radius {\r\n    border-bottom-left-radius: var(--ezBorderRadius);\r\n    border-bottom-right-radius: var(--ezBorderRadius);\r\n}\r\n\r\n\r\n/* 1px borders */\r\n.ezBorder {\r\n    border-color: var(--ezBorderColorGray);\r\n    border-style: var(--ezBorderStyle);\r\n    border-width: var(--ezBorderWidth);\r\n}\r\n\r\n.ez-border-rounded {\r\n    border-color: var(--ezBorderColorGray);\r\n    border-style: var(--ezBorderStyle);\r\n    border-width: var(--ezBorderWidth);\r\n    border-radius: var(--ezBorderRadius);\r\n}\r\n\r\n.ez-border-navy {\r\n    border-color: var(--ezBorderColorNavy);\r\n    border-style: var(--ezBorderStyle);\r\n    border-width: var(--ezBorderWidth);\r\n}\r\n\r\n.ez-border-medium-navy {\r\n    border-color: var(--ezBorderColorNavy);\r\n    border-style: var(--ezBorderStyle);\r\n    border-width: var(--ezBorderMedium);\r\n}\r\n\r\n.ez-border-medium-rounded-navy {\r\n    border-color: var(--ezBorderColorNavy);\r\n    border-style: var(--ezBorderStyle);\r\n    border-width: var(--ezBorderMedium);\r\n    border-radius: var(--ezBorderRadius);\r\n}\r\n\r\n.ez-border-medium-rounded-right-navy {\r\n    border-color: var(--ezBorderColorNavy);\r\n    border-style: var(--ezBorderStyle);\r\n    border-width: var(--ezBorderMedium);\r\n    border-top-left-radius: 0;\r\n    border-bottom-left-radius: 0;\r\n    border-top-right-radius: var(--ezBorderRadius);\r\n    border-bottom-right-radius: var(--ezBorderRadius);\r\n}\r\n\r\n.ez-border-thick-navy {\r\n    border-color: var(--ezBorderColorNavy);\r\n    border-style: var(--ezBorderStyle);\r\n    border-width: var(--ezBorderThick);\r\n    border-radius: var(----ezBorderRadius);\r\n}\r\n\r\n.ezBorders_Stone {\r\n    border-color: var(--ezBorderColorStone);\r\n    border-style: var(--ezBorderStyle);\r\n    border-width: var(--ezBorderWidth);\r\n}\r\n\r\n.ezBorders_Silver {\r\n    border-color: var(--ezBorderColorStone);\r\n    border-style: var(--ezBorderStyle);\r\n    border-width: var(--ezBorderWidth);\r\n}\r\n\r\n.ezBorders_OffWhite {\r\n    border-color: var(--ezBorderColorStone);\r\n    border-style: var(--ezBorderStyle);\r\n    border-width: var(--ezBorderWidth);\r\n}\r\n\r\n.ezBorderLeft {\r\n    /* border-color: var(--ezClockerGray); */\r\n    border-color: #6d6e70;\r\n\r\n    /* border-left-style: var(--ezBorderStyle); */\r\n    border-left-style: solid;\r\n\r\n    /* border-left-width: var(--ezBorderWidth) */\r\n    border-left-width: 1px;\r\n}\r\n\r\n.ezBorderLeftBottom {\r\n    /* border-color: var(--ezClockerGray); */\r\n    border-color: #6d6e70;\r\n\r\n    /* border-left-style: var(--ezBorderStyle); */\r\n    border-left-style: solid;\r\n\r\n    /* border-left-width: var(--ezBorderWidth) */\r\n    border-left-width: 1px;\r\n\r\n    /* border-bottom-style: var(--ezBorderStyle); */\r\n    border-bottom-style: solid;\r\n\r\n    /* border-bottom-width: var(--ezBorderWidth) */\r\n    border-bottom-width: 1px;\r\n}\r\n\r\n.ezBorderRight {\r\n    /* border-color: var(--ezClockerGray); */\r\n    border-color: #6d6e70;\r\n    border-right-style: solid;\r\n    border-right-width: 1px;\r\n}\r\n\r\n.ezBorderBottom {\r\n    /* border-color: var(--ezClockerGray); */\r\n    border-color: #6d6e70;\r\n    border-right-style: solid;\r\n    border-right-width: 1px;\r\n    border-bottom-style: solid;\r\n    border-bottom-width: 1px;\r\n}\r\n\r\n.ezBorderLeftRightBottom {\r\n    /* border-color: var(--ezClockerGray); */\r\n    border-color: #6d6e70;\r\n    border-left-style: solid;\r\n    border-left-width: 1px;\r\n    border-right-style: solid;\r\n    border-right-width: 1px;\r\n    border-bottom-style: solid;\r\n    border-bottom-width: 1px;\r\n}\r\n\r\n.ezSolidBorder1 {\r\n    /* border-color: var(--ezClockerGray); */\r\n    border-color: #6d6e70;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n}\r\n\r\n.ezSolidBorderTop1 {\r\n    /* border-color: var(--ezClockerGray); */\r\n    border-color: #6d6e70;\r\n    border-top-style: solid;\r\n    border-top-width: 1px;\r\n}\r\n\r\n.ezSolidBorderBottom1 {\r\n    /* border-color: var(--ezClockerGray); */\r\n    border-color: #6d6e70;\r\n    border-bottom-style: solid;\r\n    border-bottom-width: 1px;\r\n}\r\n\r\n.ezSolidBorderTopBottom1 {\r\n    /* border-color: var(--ezClockerGray); */\r\n    border-color: #6d6e70;\r\n    border-top-style: solid;\r\n    border-top-width: 1px;\r\n    border-bottom-style: solid;\r\n    border-bottom-width: 1px;\r\n}\r\n\r\n.ezSolidBorderLeft1 {\r\n    /* border-color: var(--ezClockerGray); */\r\n    border-color: #6d6e70;\r\n    border-left-style: solid;\r\n    border-left-width: 1px;\r\n}\r\n\r\n.ezSolidBorderRight1 {\r\n    /* border-color: var(--ezClockerGray); */\r\n    border-color: #6d6e70;\r\n    border-right-style: solid;\r\n    border-right-width: 1px;\r\n}\r\n\r\n.ezSolidBorderLeftRigt1 {\r\n    /* border-color: var(--ezClockerGray); */\r\n    border-color: #6d6e70;\r\n    border-left-style: solid;\r\n    border-left-width: 1px;\r\n    border-right-style: solid;\r\n    border-right-width: 1px;\r\n}\r\n\r\n/* 2px borders */\r\n.ezSolidBorder2 {\r\n    /* border-color: var(--ezClockerGray); */\r\n    border-color: #6d6e70;\r\n    border-style: solid;\r\n    border-width: 2px;\r\n}\r\n\r\n.ezSolidBorderTop2 {\r\n    /* border-color: var(--ezClockerGray); */\r\n    border-color: #6d6e70;\r\n    border-top-style: solid;\r\n    border-top-width: 2px;\r\n}\r\n\r\n.ezSolidBorderBottom2 {\r\n    /* border-color: var(--ezClockerGray); */\r\n    border-color: #6d6e70;\r\n    border-bottom-style: solid;\r\n    border-bottom-width: 2px;\r\n}\r\n\r\n.ezSolidBorderTopBottom2 {\r\n    /* border-color: var(--ezClockerGray); */\r\n    border-color: #6d6e70;\r\n    border-top-style: solid;\r\n    border-top-width: 2px;\r\n    border-bottom-style: solid;\r\n    border-bottom-width: 2px;\r\n}\r\n\r\n.ezSolidBorderLeft2 {\r\n    /* border-color: var(--ezClockerGray); */\r\n    border-color: #6d6e70;\r\n    border-left-style: solid;\r\n    border-left-width: 2px;\r\n}\r\n\r\n.ezSolidBorderRight2 {\r\n    /* border-color: var(--ezClockerGray); */\r\n    border-color: #6d6e70;\r\n    border-right-style: solid;\r\n    border-right-width: 2px;\r\n}\r\n\r\n.ezSolidBorderLeftRigt2 {\r\n    /* border-color: var(--ezClockerGray); */\r\n    border-color: #6d6e70;\r\n    border-left-style: solid;\r\n    border-left-width: 2px;\r\n    border-right-style: solid;\r\n    border-right-width: 2px;\r\n}\r\n\r\n/* 4px borders */\r\n.ezSolidBorder4 {\r\n    /* border-color: var(--ezClockerGray); */\r\n    border-color: #6d6e70;\r\n    border-style: solid;\r\n    border-width: 4px;\r\n}\r\n\r\n.ezSolidBorderTop4 {\r\n    /* border-color: var(--ezClockerGray); */\r\n    border-color: #6d6e70;\r\n    border-top-style: solid;\r\n    border-top-width: 4px;\r\n}\r\n\r\n.ezSolidBorderBottom4 {\r\n    /* border-color: var(--ezClockerGray); */\r\n    border-color: #6d6e70;\r\n    border-bottom-style: solid;\r\n    border-bottom-width: 4px;\r\n}\r\n\r\n.ezSolidBorderTopBottom4 {\r\n    /* border-color: var(--ezClockerGray); */\r\n    border-color: #6d6e70;\r\n    border-top-style: solid;\r\n    border-top-width: 4px;\r\n    border-bottom-style: solid;\r\n    border-bottom-width: 4px;\r\n}\r\n\r\n.ezSolidBorderLeft4 {\r\n    /* border-color: var(--ezClockerGray); */\r\n    border-color: #6d6e70;\r\n    border-left-style: solid;\r\n    border-left-width: 4px;\r\n}\r\n\r\n.ezSolidBorderRight4 {\r\n    /* border-color: var(--ezClockerGray); */\r\n    border-color: #6d6e70;\r\n    border-right-style: solid;\r\n    border-right-width: 4px;\r\n}\r\n\r\n.ezSolidBorderLeftRigt4 {\r\n    /* border-color: var(--ezClockerGray); */\r\n    border-color: #6d6e70;\r\n    border-left-style: solid;\r\n    border-left-width: 4px;\r\n    border-right-style: solid;\r\n    border-right-width: 4px;\r\n}\r\n\r\n.ezRadius2 {\r\n    border-radius: 2px;\r\n}\r\n\r\n.ezRadiusTopLeft2 {\r\n    border-top-left-radius: 2px;\r\n}\r\n\r\n.ezRadisuTopRight2 {\r\n    border-top-right-radius: 2px;\r\n}\r\n\r\n.ezRadiusTop2 {\r\n    border-top-left-radius: 2px;\r\n    border-top-right-radius: 2px;\r\n}\r\n\r\n.ezRadiusBottomLeft2 {\r\n    border-bottom-left-radius: 2px;\r\n}\r\n\r\n.ezRadisuBottomRight2 {\r\n    border-bottom-right-radius: 2px;\r\n}\r\n\r\n.ezRadisuBottom2 {\r\n    border-bottom-left-radius: 2px;\r\n    border-bottom-right-radius: 2px;\r\n}\r\n\r\n.ezRadiusLeft2 {\r\n    border-top-left-radius: 2px;\r\n    border-bottom-left-radius: 2px;\r\n}\r\n\r\n.ezRadiusRight2 {\r\n    border-top-right-radius: 2px;\r\n    border-bottom-right-radius: 2px;\r\n}\r\n\r\n.ezRadius4 {\r\n    border-radius: 4px;\r\n}\r\n\r\n.ezRadiusTopLeft4 {\r\n    border-top-left-radius: 4px;\r\n}\r\n\r\n.ezRadiusTopRight4 {\r\n    border-top-right-radius: 4px;\r\n}\r\n\r\n.ezRadiusTop4 {\r\n    border-top-left-radius: 4px;\r\n    border-top-right-radius: 4px;\r\n}\r\n\r\n.ezRadiusBottomLeft4 {\r\n    border-bottom-left-radius: 4px;\r\n}\r\n\r\n.ezRadisuBottomRight4 {\r\n    border-bottom-right-radius: 4px;\r\n}\r\n\r\n.ezRadisuBottom4 {\r\n    border-bottom-left-radius: 4px;\r\n    border-bottom-right-radius: 4px;\r\n}\r\n\r\n.ezRadiusLeft4 {\r\n    border-top-left-radius: 4px;\r\n    border-bottom-left-radius: 4px;\r\n}\r\n\r\n.ezRadiusRight4 {\r\n    border-top-right-radius: 4px;\r\n    border-bottom-right-radius: 4px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
